module.exports = __webpack_public_path__ + "img/7E5344_22120E_CCAB9C_8D919D-256px.f59078af.png";